import { useNavState } from '@/providers/NavStateProvider';
import { useEffect, useState } from 'react';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { MotionDiv } from '@/components/element/MotionDiv';
import { useLoading } from '@/providers/LoadingProvider';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { v4 as uuidV4 } from 'uuid';
import Cookies from 'js-cookie';
import { toastApiError, toastError, toastSuccess } from '@/lib/toast';
import { useCreateSlackSetting } from '@/hooks/api/2240_create_slack_setting';
import { useWorkspaceInvalidate } from '@/hooks/api/0101_workspace';

export const SlackConnectCallback = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('通知設定'), []);
  useEffect(() => setBreadcrumbs([]), []);

  const { setShowLoading } = useLoading();
  const { _w_, me } = useCurrentWorkspace();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { mutate, data, isPending, error } = useCreateSlackSetting();
  const { invalidate: invalidateWorkspace } = useWorkspaceInvalidate(_w_!.identifier);

  useEffect(() => setShowLoading(isPending), [isPending]);

  useEffect(() => {
    const _code = params.get('code');
    const _state = params.get('state');

    if (_code && _state == Cookies.get('slack_connect_state')) {
      mutate({ identifier: _w_!.identifier, code: _code });
      Cookies.remove('slack_connect_state');
    } else {
      toastError('Slack連携に失敗しました');
      navigate(`/w/${_w_!.identifier}/user_setting/notification`);
    }
  }, []);

  useEffect(() => {
    if (error) {
      toastApiError(error);
      navigate(`/w/${_w_!.identifier}/user_setting/notification`);
    }
  }, [error]);

  useEffect(() => {
    if (data) {
      invalidateWorkspace();
      toastSuccess('Slack連携が完了しました');
      navigate(`/w/${_w_!.identifier}/user_setting/notification`);
    }
  }, [data]);

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <div className="row">
          <div className="col-12 col-lg-6 mx-auto">
            <MotionDiv className="card mb-4">
              <div className="card-header d-flex align-items-center">
                <div className="col-md-8">
                  <h5 className="mb-0">通知設定</h5>
                </div>
              </div>
              <div className="card-body pt-0 row">
                <div className="form-group">
                  <label>Slack連携</label>
                  <div>
                    <a href="#">
                      <img
                        alt="Add to Slack"
                        height="40"
                        width="139"
                        src="https://platform.slack-edge.com/img/add_to_slack.png"
                        srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
                      />
                    </a>
                  </div>
                  <div className="text-xs text-muted mt-2">通知をSlackで受け取れます。</div>
                </div>
              </div>
            </MotionDiv>
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
